import {
  LNRPDownloadDto,
  LnrpDownloadResponseDto,
  LnrpLoginDto,
  LnrpLoginResponseDto,
} from '@cratehackers/api-client';
import ApiService from './Api.service';

export class LnrpService {
  public static async lnrpLogin(
    username: string,
    password: string,
  ): Promise<LnrpLoginResponseDto> {
    const api = ApiService.getApiClient();
    const dto: LnrpLoginDto = { username, password };
    return await api.lnrpControllerLogin({ lnrpLoginDto: dto });
  }

  public static async lnrpStatus(): Promise<{
    loggedIn: boolean;
    token?: string;
    userId?: string;
    status?: string;
    username?: string;
  }> {
    const api = ApiService.getApiClient();
    return await api.lnrpControllerStatus();
  }

  public static async lnrpLogout() {
    const api = ApiService.getApiClient();
    await api.lnrpControllerLogout();
  }

  public static async lnrpGenerateDownload(
    mediaId: string,
    auth: string,
  ): Promise<LnrpDownloadResponseDto> {
    const api = ApiService.getApiClient();
    const dto: LNRPDownloadDto = { mediaId, auth };

    try {
      return await api.lnrpControllerGenerateDownload({ lNRPDownloadDto: dto });
    } catch (error: any) {
      // Extract status code from API client error and rethrow with status
      const statusCode =
        error?.response?.status || error?.status || error?.code;
      const newError = new Error(error?.message || 'LNRP download failed');
      (newError as any).status = statusCode;
      (newError as any).response = { status: statusCode };
      throw newError;
    }
  }
}
